/** Legal notes */
export const TERMS_OF_SERVICE_URL = 'https://paradex.trade/terms-of-service';
/** Legal notes */
export const PRIVACY_POLICY_URL = 'https://www.paradex.trade/privacy-policy';
/** Legal notes */
export const ABOUT_RESTRICTED_PERSONS_URL =
  'https://paradex.trade/restricted-persons';
/** Paradex product docs site */
export const PRODUCT_DOCS_URL = 'https://docs.paradex.trade/';
/** Paradex statistics */
export const STATS_URL = 'https://www.paradex.trade/stats';
/** Paradex Blog */
export const BLOG_URL = 'https://www.paradex.trade/blog';
/** Paradex Discord server */
export const DISCORD_URL = 'https://discord.gg/paradex';
/** URL to Paradex github code samples */
export const CODE_SAMPLES_URL = 'https://github.com/tradeparadex';
/** URL to Paradex twitter user */
export const TWITTER_URL = 'https://twitter.com/tradeparadex';
/** URL to Paradex announcements TG channel */
export const ANNOUNCEMENTS_URL = 'https://t.me/paradex_announcements';
/** URL to documentation explaining how deleverage works */
export const DELEVERAGE_DOCS_URL =
  'https://docs.paradex.trade/risk-system/deleveraging';
/** URL to documentation explaining health checks */
export const UNHEALTHY_DOCS_URL =
  'https://docs.paradex.trade/risk-system/paradex-risk-checks#health-check';
/** URL to documentation explaining liquidation */
export const LIQUIDATION_DOCS_URL =
  'https://docs.paradex.trade/risk-system/liquidations';
/** URL to documentation explaining deposit / withdrawal */
export const DEPOSITS_WITHDRAWALS_DOCS_URL =
  'https://docs.paradex.trade/deposits-and-withdrawals/overview';
export const PARADEX_L2_ADDRESS_DOCS_URL =
  'https://docs.paradex.trade/introduction/onboarding-and-wallets';
/** URL to documentation explaining Points program */
export const POINTS_DOCS_URL = 'https://docs.paradex.trade/paradex-points';
export const CLOCK_SYNCHRONIZATION_DOCS_URL =
  'https://docs.paradex.trade/introduction/onboarding-and-wallets#clock-synchronization';
/** URL to documentation explaining Socialized Loss concept */
export const SOCIALIZED_LOSS_DOCS_URL =
  'https://docs.paradex.trade/risk-system/socialized-losses';
export const MARKETING_REBEL_RISING_URL =
  'https://www.paradex.trade/rebel-rising';
